import apiHandler from "../core/apiHandler";
const businessApi = apiHandler('business-configuration');
export default businessApi;